/**
 * Copyright Open Logistics Foundation
 *
 * Licensed under the Open Logistics Foundation License 1.3.
 * For details on the licensing terms, see the LICENSE file.
 * SPDX-License-Identifier: OLFL-1.3
 */

import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
    MatDialogTitle,
    MatDialogClose,
    MatDialogActions,
    MatDialogRef,
} from '@angular/material/dialog';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

/** Language codes accepted by the eCMR PDF endpoints (`?language=`). */
export type EcmrPdfLanguage = 'EN' | 'ES';

@Component({
    selector: 'app-ecmr-pdf-language-dialog',
    templateUrl: './ecmr-pdf-language-dialog.component.html',
    imports: [
        FormsModule,
        MatDialogTitle,
        MatIconButton,
        MatDialogClose,
        MatIcon,
        MatRadioGroup,
        MatRadioButton,
        MatDialogActions,
        MatButton,
        TranslateModule,
    ],
})
export class EcmrPdfLanguageDialogComponent {
    language: EcmrPdfLanguage;

    constructor(
        private dialogRef: MatDialogRef<
            EcmrPdfLanguageDialogComponent,
            EcmrPdfLanguage
        >,
        translateService: TranslateService
    ) {
        // Pre-select Spanish when the UI is currently Spanish, otherwise default to English.
        this.language = translateService.currentLang === 'es' ? 'ES' : 'EN';
    }

    download() {
        this.dialogRef.close(this.language);
    }
}
